export const searchIssues = /* GraphQL */ `
  query SearchIssues(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $limit: Int
    $nextToken: String
  ) {
    searchUserResources(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sk
        workspaceId
        type
        name
        description
        idInc
        idVendor
        issueKey
        maturity
        bankId
        priority
        resourceId
        resolutionType
        resolutionText
        resolutionAt
        resolutionUserId
        assigneeId
        alignments {
          items {
            id
            idPublisher
            abbreviation
            scope
            content
          }
        }
        creator {
          firstName
          lastName
          email
        }
        resource {
          id
          sk
          workspaceId
          type
          name
          idInc
          idVendor
          maturity
          bankId
          assigneeId
          language
          grade
          subject
          dok
          blooms
          keywords
          creator {
            firstName
            lastName
            email
          }
          alignments {
            items {
              id
              idPublisher
              abbreviation
              scope
              content
            }
          }
        }
        createdAt
        updatedAt
        __typename
      }
      aggregations {
        assetType {
          key
          count
        }
        mediaType {
          key
          count
        }
        maturity {
          key
          count
        }
        type {
          key
          count
        }
        subject {
          key
          count
        }
        grade {
          key
          count
        }
        language {
          key
          count
        }
        alignmentIds {
          key
          count
        }
        objectiveScope {
          key
          count
        }
        objectiveId {
          key
          count
        }
      }
      nextToken
      total
      __typename
    }
  }
`;
